import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IInquiryCndsState, IUserItemState, IUserListItemState, IUsr0202MState } from '../../models/usr/usr0202m_model';
  
const initialState: IUsr0202MState = {
    userList: [],           // 사용자정보
    userDatas: [],          // 근속현황목록


    inquiryCnds: {
        empNo   : '',       // 사원번호
        baseDt  : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD')        // 기준년일자
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current : 0,            // 현재페이지
}

export const usr0202m_Slice = createSlice({
    name: "usr0202m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , userList: state.userList});
        },
        setUserDatas: (state, action:PayloadAction<IUserListItemState[]>) => {
            state.userDatas = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0202m_Slice.reducer;
export const Usr0202mAction  = usr0202m_Slice.actions;
export const Usr0202mReducer = usr0202m_Slice.reducer;